import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ButtonGroup, Button, Form, Row, Col, Input } from 'reactstrap';
import { Utils } from '../../../services';
import { Loader } from '../../../components';
import { loadTasks } from '../../../redux';
import Widget from '../Widget';
import WidgetSharedSettings from '../WidgetSharedSettings/WidgetSharedSettings';
import moment from 'moment';
import _ from 'lodash';

import './UserPlanning.css';


const UserPlanning = ({ props, saveSettings, index, onCancel, border, insert, name }) => {
    const { t, i18n } = useTranslation();
    const dispatch    = useDispatch();

    const me = useSelector(state => state.auth.user);

    const { tasks, isLoading, loadingErrorMessage } = useSelector(state => state.tasks);

    //Use this function to format props to send to parent
    //Index of edited widget is passed here then back to parent so we need it
    const handleSubmit = (e) => {
        //Prevent refresh on form submit
        e.preventDefault();

        let settings = { width: e.target.widgetWidth.value, }

        //IN ARRAY!
        saveSettings([settings, index, insert, name]);
    }

    useEffect(() => {
        dispatch(loadTasks({
            user_id: me.id,
            start_at_gte: moment(),
        }));
    }, [dispatch, me])

    const myTasks = React.useMemo(() => {
        if (!me || !tasks?.length)
            return [];

        return _.sortBy(
            tasks.filter(t => t.user_id === me.id),
            'start_at'
        );
    }, [tasks, me]);

    const content = React.useMemo(() => {
        moment.locale(i18n.language);
        const activities =  _.uniqBy(myTasks.map(t => t.activity), 'id');
        return (
            <Row className="flex-1">
                <Col>
                    <div className='h-10 border-bottom'>
                        <h5>{ t('widgets.title_desc.userPlanning') }</h5>
                    </div>

                    {isLoading && (
                        <Loader />
                    )}

                    {!isLoading && loadingErrorMessage && (
                        <h6 className="mt-2 text-italic text-danger">
                            { loadingErrorMessage }
                        </h6>
                    )}

                    {!isLoading && !loadingErrorMessage && myTasks?.length > 0 && (
                    <>
                        <h6 className="mt-3">
                            { t('widgets.title_desc.userPlanning_desc') }
                        </h6>
                        <table className="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>{ t('tasks.timing') }</th>
                                    <th>{ t('tasks.sector') }</th>
                                </tr>
                            </thead>
                            <tbody>
                                {myTasks?.map(task => (
                                <tr key={ task.id }>
                                    <td>
                                        <div className="d-flex justify-between">
                                            <div>
                                                <b>{moment(task.start_at).format('ll')}</b>&nbsp;
                                            </div>
                                            <div classname="text-right">
                                                {moment(task.start_at).format('LT')}&nbsp;&#x279F;&nbsp;
                                                {moment(task.stop_at).format('LT')}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {(activities.length > 1) && task.activity && Utils.localized_or_fallback(task.activity.name, i18n.language)}
                                        { Utils.localized_or_fallback(task.shift.sector.name, i18n.language) }
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="text-center">
                            <ButtonGroup>
                                {me && (
                                    <Button tag={Link} to={`/users/edit/${me?.id}#team`} className="btn btn-warning">
                                        <i className="fa fa-pencil" />&nbsp;
                                        { t('widgets.change_availabilities') }
                                    </Button>
                                )}
                                <Button tag={Link} to="/tasks" className="btn btn-info">
                                    <i className="fa fa-calendar" />&nbsp;
                                    { t('widgets.go_to_planning') }
                                </Button>
                            </ButtonGroup>
                        </div>
                    </>
                    )}

                    {!isLoading && !loadingErrorMessage && tasks?.length === 0 && (
                        <h6 className="mt-2 text-italic">
                            { t('widgets.no_planning_entries') }
                        </h6>
                    )}
                </Col>
            </Row>
        );
    }, [myTasks, i18n.language]);

    if (saveSettings)
        return (
            <div className='UserPlanning'>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col>
                            <div className='pb-2 border-bottom'>
                                <WidgetSharedSettings
                                    width={props?.width ? props.width : 1}
                                    bgColor={props?.bgColor ? props.bgColor : "rgb(0,0,0,0)"}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="submitButtons">
                                <Button onClick={() => onCancel()} className="mr-2" color="danger"><i className="fa fa-times"></i>&nbsp;{t("widgets.cancel")}</Button>&nbsp;
                                <Button type="submit" color="success"><i className="fa fa-floppy-o"></i>&nbsp;{t("widgets.save")}</Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        );

    return (
        <div className='UserPlanning'>
            <Widget
                content={ content }
                border={border && border}
            />
        </div>
    )
}

export default UserPlanning;
